"use strict";

exports.__esModule = true;
exports.getAppIcon = getAppIcon;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const colors = {
  "blue": "#0067b6",
  "red": "#eb314e"
};

function getAppIcon({
  fill,
  text,
  type = "filled"
}) {
  if (fill && colors[fill]) {
    fill = colors[fill];
  }

  if (type === "filled") {
    return _react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "64",
      height: "64",
      viewBox: "0 0 64 64"
    }, _react.default.createElement("rect", {
      x: "10",
      y: "10",
      width: "44",
      height: "44",
      fill: fill
    }), _react.default.createElement("text", {
      x: "32",
      y: "34",
      fill: "white",
      fontFamily: "Akkurat, sans-serif",
      fontSize: "18",
      fontWeight: "bold",
      dominantBaseline: "middle",
      textAnchor: "middle"
    }, text));
  } else {
    return _react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "64",
      height: "64",
      viewBox: "0 0 64 64"
    }, _react.default.createElement("rect", {
      x: "10",
      y: "10",
      width: "44",
      height: "44",
      fill: fill
    }), _react.default.createElement("rect", {
      x: "13",
      y: "13",
      width: "38",
      height: "38",
      fill: "white"
    }), _react.default.createElement("text", {
      x: "32",
      y: "34",
      fill: "black",
      fontFamily: "Akkurat, sans-serif",
      fontSize: "18",
      fontWeight: "bold",
      dominantBaseline: "middle",
      textAnchor: "middle"
    }, text));
  }
}

var _default = getAppIcon;
exports.default = _default;